import { extendObservable, action } from 'mobx';

export class Constraint {
  constructor(text, rule) {
    extendObservable(this, {
      text,
      rule,
      state: null,
    });
  }

  setState = action((state) => {
    this.state = state;
  });

  test = (value) => {
    if (value === null || value === void 0 || "") {
      this.setState();
    }

    let isValid = false;
    if (typeof this.rule === "function") {
      isValid = this.rule(value);
    } else if (this.rule instanceof RegExp) {
      isValid = this.rule.test(value);
    } else {
      throw new Error("Invalid rule");
    }
    this.setState(isValid ? "success" : "error");
    return isValid;
  }
}

export default Constraint;


// WEBPACK FOOTER //
// ./src/models/Constraint.js